/**
 * Created by Vladislav on 25.09.2024.
 */

const WandsMenuBarItem = {
    name: "WandsItem",
    plusButton: false,
    targets: "wands",
    value: function () {
        return Map2dLocation.currentLocation.wands;
    },
    updater: function (f) {
        Map2dLocation.currentLocation.onChangeWandsListener = f;
    },
    onClickWindow: () => GuideWindow,
    onClickOptions: function () {
        const location = cleverapps.meta.getSelectedLocation();
        return !location.locationConfig.isMain ? ExpeditionWandsGuideOptions : {
            name: "WandsGuideWindow",
            bundle: bundles.wandsguidewindow
        };
    },
    icon: function () {
        return cleverapps.skins.getSlot("merge_wand_png") || bundles.menubar.frames.merge_wand_png;
    },
    incEffect: "menubar.wand.fly_finish",
    decEffect: "menubar.wand.fly_finish",
    availableOnScenes: function () {
        const locationConfig = cleverapps.meta.getSelectedLocation().locationConfig;
        if (locationConfig.usesWands) {
            return [cleverapps.Environment.SCENE_MAIN];
        }
    },
    sparks: true,

    onDebugClick: function () {
        Map2dLocation.currentLocation.setWands(Map2dLocation.currentLocation.wands + 100);
    }
};